'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAvailabilityAwayMessage = undefined;

var _reselect = require('reselect');

var _getAwayMessage = require('conversations-schema/availability/operators/config/getAwayMessage');

var _getWidgetAvailabilityOptions = require('./getWidgetAvailabilityOptions');

var getAvailabilityAwayMessage = exports.getAvailabilityAwayMessage = (0, _reselect.createSelector)([_getWidgetAvailabilityOptions.getWidgetAvailabilityOptions], function (availabilityOptions) {
  return (0, _getAwayMessage.getAwayMessage)(availabilityOptions) || '';
});


//////////////////
// WEBPACK FOOTER
// ./js/availability/selectors/getAvailabilityAwayMessage.js
// module id = 214
// module chunks = 2 3